// extracted by mini-css-extract-plugin
export var benefit = "pricing-module--benefit--adb77";
export var benefitCopy = "pricing-module--benefitCopy--54425";
export var benefits = "pricing-module--benefits--ce9a9";
export var benefitsContainer = "pricing-module--benefitsContainer--1b4bc";
export var benefitsTitle = "pricing-module--benefitsTitle--252fb";
export var clientGreenBg = "pricing-module--clientGreenBg--91f5c";
export var ctaContainer = "pricing-module--ctaContainer--8d943";
export var darkTealBg = "pricing-module--darkTealBg--7aa48";
export var desktopSquiggle = "pricing-module--desktopSquiggle--90053";
export var disclaimerContainer = "pricing-module--disclaimerContainer--8cdb4";
export var disclaimerCopy = "pricing-module--disclaimerCopy--8e362";
export var headerContainer = "pricing-module--headerContainer--1e8c3";
export var headerCopyContainer = "pricing-module--headerCopyContainer--d289d";
export var mobileSquiggle = "pricing-module--mobileSquiggle--c75ea";
export var moduleContainer = "pricing-module--moduleContainer--740f1";
export var priceContainer = "pricing-module--priceContainer--717c5";
export var priceSubheader = "pricing-module--priceSubheader--5d441";
export var pricing = "pricing-module--pricing--474fd";
export var pricingCard = "pricing-module--pricingCard--961a2";
export var pricingContainer = "pricing-module--pricingContainer--ff8ba";
export var squiggle = "pricing-module--squiggle--33bb4";